module.exports = __webpack_public_path__ + "img/code.d2f23716.jpg";